import { SystemProp, Theme, x } from '@xstyled/styled-components';
import React from 'react';
import { CSS } from '@react-spring/web';
import {
  Item,
  ItemDefinition,
  ItemValidationError,
  registry,
  RenderProps
} from '../Item';
import { BACKGROUND, COLOR, IMAGE, ROOT, VIDEO } from '../itemIds';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';
import { Logo } from '~/ui/logo/Logo';

interface Props {
  value?: string;
  opacity: number;
  isVideo?: boolean;
  //i have added this property, because we need to have specific behavior for Images1 template
  backgroundSizeForMobile?: string;
  direction?: SystemProp<CSS.Property.FlexDirection, Theme>;
  showLogo?: boolean;
}

const acceptedChildren = [COLOR, IMAGE, VIDEO];

export type BackgroundDefinition = ItemDefinition<typeof BACKGROUND, Props>;

const selector = (s: TrainingState) => select(s, 'logoUrl');

export class Background extends Item<typeof BACKGROUND, Props> {
  protected validate(): void {
    if (this.parent && this.parent.type !== ROOT)
      throw new ItemValidationError(
        `An item of type [${BACKGROUND}] must be the child of an item of type ${ROOT}`
      );

    if (this.definition.items?.some(i => !acceptedChildren.includes(i.type))) {
      throw new ItemValidationError(
        `An item of type [${BACKGROUND}] can only have children of type [${acceptedChildren.join(
          ', '
        )}]`
      );
    }
  }

  protected render({
    id,
    value,
    opacity = 100,
    isVideo,
    children,
    direction,
    showLogo
  }: RenderProps<Props>) {
    const { logoUrl } = useTrainingStore(selector);

    return (
      <>
        <x.div
          backgroundColor={value}
          w="100%"
          h="100%"
          display="flex"
          flexDirection={direction || { _: 'column', lg: 'row' }}
          position="relative"
          zIndex={isVideo ? 0 : -1}
          style={{ filter: `brightness(${opacity / 100})` }}
        >
          {children}
          {showLogo ? (
            <Logo
              src={logoUrl}
              style={{
                position: 'absolute',
                right: '10%',
                bottom: '10%',
                maxWidth: '250px',
                maxHeight: '250px'
              }}
            />
          ) : (
            false
          )}
        </x.div>
      </>
    );
  }
}

registry[BACKGROUND] = Background;
